import { render, staticRenderFns } from "./QColorPicker.vue?vue&type=template&id=2437ba6a&scoped=true&"
import script from "./QColorPicker.vue?vue&type=script&lang=js&"
export * from "./QColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./QColorPicker.vue?vue&type=style&index=0&id=2437ba6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437ba6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VColorPicker,VIcon,VMenu,VTextField})
